import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  signal,
} from '@angular/core';
import { ListingDetailService } from '../../../services/listing-detail.service';
import { PlanContentComponent } from '../plan-content/plan-content.component';
import { PlanSummaryComponent } from '../plan-summary/plan-summary.component';

type SnapState = 'peek' | 'full';

@Component({
  selector: 'app-plan-sheet',
  standalone: true,
  imports: [PlanContentComponent, PlanSummaryComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './plan-sheet.component.html',
  styleUrl: './plan-sheet.component.css',
})
export class PlanSheetComponent {
  private readonly detailService = inject(ListingDetailService);

  readonly snap = signal<SnapState>('peek');

  private touchStartY: number | null = null;
  private swiped = false;

  @HostBinding('class.hidden')
  get hidden(): boolean {
    return this.detailService.openedId() !== null;
  }

  @HostBinding('attr.data-snap')
  get snapAttr(): SnapState {
    return this.snap();
  }

  onGrabberClick(): void {
    if (this.swiped) {
      this.swiped = false;
      return;
    }
    this.snap.set(this.snap() === 'peek' ? 'full' : 'peek');
  }

  onTouchStart(ev: TouchEvent): void {
    this.touchStartY = ev.touches[0].clientY;
    this.swiped = false;
  }

  onTouchEnd(ev: TouchEvent): void {
    if (this.touchStartY === null) {
      return;
    }
    const deltaY = ev.changedTouches[0].clientY - this.touchStartY;
    this.touchStartY = null;
    const THRESHOLD = 30; // px - distinguishes a flick from a tap
    if (deltaY < -THRESHOLD) {
      this.swiped = true;
      this.snap.set('full');
    } else if (deltaY > THRESHOLD) {
      this.swiped = true;
      this.snap.set('peek');
    }
  }

  onGrabberKeydown(ev: KeyboardEvent): void {
    if (ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      this.onGrabberClick();
    }
  }
}
